export default __webpack_public_path__ + "static/signature-m6-9d6bae7d5d5cce7147bb1e546e83f5d3.png";